import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
  Divider,
  Heading,
  Message,
} from 'rebass';

import DarkerBox from 'frontend/components/DarkerBox';
import { Flex, Box } from 'reflexbox';

import {
  MAX_LEVEL,
  characterLootSpecMismatch,
  getIncorrectArmorPieces,
} from 'shared/character';
import {
  getIncorrectMainStatPieces,
} from 'shared/items';

import SvgIcons from 'frontend/SvgIcons';
import If from 'frontend/components/If';

import config from 'frontend/config';

import { selectors as simbotSelectors } from 'frontend/state/reducers/simbot';

import ArmoryInput from './ArmoryInput';
import SimcUserInput from './SimcUserInput';


const CharacterInputPanel = ({ character }) => {
  let invalidArmor;
  let wrongMainStatPieces;
  let lootSpecMismatch;
  if (character) {
    invalidArmor = getIncorrectArmorPieces(character);
    wrongMainStatPieces = getIncorrectMainStatPieces(character);
    lootSpecMismatch = characterLootSpecMismatch(character);
  }

  return (
    <DarkerBox md={10}>
      <Flex align="center" mb={1}>
        <SvgIcons.charImport.small
          style={{
            height: 28,
            width: 28,
            fill: config.colors.iconInfo,
          }}
        />
        <Heading level={4} mb={0} ml={1} style={{ letterSpacing: '0.1em' }}>
          Load from Armory
        </Heading>
      </Flex>

      <ArmoryInput />

      <Flex align="center" justify="space-between">
        <Box auto>
          <Divider />
        </Box>
        <Box mx={3}>
          <Heading level={6} color={config.colors.iconInfo}>
            or
          </Heading>
        </Box>
        <Box auto>
          <Divider />
        </Box>
      </Flex>

      <Flex align="center" mb={1}>
        <SvgIcons.input.small
          style={{
            height: 28,
            width: 28,
            fill: config.colors.iconInfo,
          }}
        />
        <Heading level={4} mb={0} ml={1} style={{ letterSpacing: '0.1em' }}>
          Load from SimC Addon
        </Heading>
      </Flex>

      <SimcUserInput />

      <If
        condition={lootSpecMismatch}
        then={() => (
          <Box>
            <Message theme="warning" p={1} mt={1}>
              Spec and Loot Spec do not match. Double check you are simming the spec you think you are!
            </Message>
          </Box>
        )}
      />
      <If
        condition={character && character.level < MAX_LEVEL}
        then={() => (
          <Box>
            <Divider />
            <Message theme="warning" p={1} mt={1}>
              Lower level characters are not well supported. Invalid results or errors are possible.
            </Message>
          </Box>
        )}
      />
      <If
        condition={_.size(invalidArmor) > 0}
        then={() => (
          <Box>
            <Divider />
            <Message theme="warning" p={1} mt={1}>
              Character has wrong armor type equipped in some slots: {_.join(_.map(invalidArmor, 'name'), ', ')}
            </Message>
          </Box>
        )}
      />
      <If
        condition={_.size(wrongMainStatPieces) > 0}
        then={() => (
          <Box>
            <Message theme="warning" p={1} mt={1}>
              Character has wrong main stat equipped in some slots:
              {' '}
              {_.join(_.map(wrongMainStatPieces, 'name'), ', ')}
            </Message>
          </Box>
        )}
      />
    </DarkerBox>
  );
};

CharacterInputPanel.propTypes = {
  character: PropTypes.shape({
    level: PropTypes.number,
  }),
};

CharacterInputPanel.defaultProps = {
  character: null,
};

const mapStateToProps = (state, props) => ({
  character: simbotSelectors.character(state, props),
});

export default connect(mapStateToProps)(CharacterInputPanel);
